import { FccOperatorRoleType } from '@backoffice-frontend/graphql'
import { type AdWorkspace, useOptionalAdWorkspace } from './AdWorkspace'

const workspaceOperatorRole: Record<
  AdWorkspace,
  FccOperatorRoleType | undefined
> = {
  'ad-fleet-map': undefined,
  'rider-support': FccOperatorRoleType.RiderSupport,
  'remote-assistance-operator': FccOperatorRoleType.RemoteAssistanceOperator,
}

export const useWorkspaceOperatorRole = (): FccOperatorRoleType | undefined => {
  const workspace = useOptionalAdWorkspace()
  return workspace ? workspaceOperatorRole[workspace] : undefined
}
